import "./App.css";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Bio from "./pages/Bio";
import Experiencias from "./pages/Experiencias";
import Home from "./pages/Home";

function App() {
  return (
    <main>
      <Header />
      <Home />
      <Bio />
      <Experiencias />
      <Footer />
    </main>
  );
}

export default App;
